// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Hesy","content":"styles_content__qGTzj"};